import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import '../ui-inlined-svg/ui-inlined-svg';

const CName = 'ui-bold-checkmark-icon';

@customElement(CName)
export class UIBoldCheckmarkIcon extends LitElement {
  render() {
    // Use vite to transform static URL
    const assetUrl = new URL('/assets/ui-core/icons/bold-checkmark-icon.svg', import.meta.url).href;
    return html`<ui-inlined-svg .defer=${true} .src=${assetUrl}></ui-inlined-svg>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIBoldCheckmarkIcon;
  }
}
